import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import testimonials from '../data/testimonials';
import industries from '../data/industries';
import { getProducts } from '../data/products';
import BrandsWith from '../components/BrandsWith';

const Home = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    document.title = "JB Corporation | Rack & Pinion, Ball Screws, Linear Motion Guides Supplier in Ahmedabad Gujarat";
  }, []);
  useEffect(() => {
    async function fetchProducts() {
      const productsData = await getProducts();
      setProducts(productsData);
    }
    fetchProducts();
  }, []);

  const [products, setProducts] = useState([]);
  console.log(products)
  return (
    <>
      <section className="hero">
        <div className="hero-container">
          {/* LEFT CONTENT */}
          <div className="hero-text">
            <h1>Welcome to <span> JB Corporation Ahmedabad </span></h1>
            <h2>
  Your trusted partner for complete Linear Motion Product Solutions in Gujarat India.
            </h2>
            <p>
              We specialize in Manufacturing and supplying premium-quality LM Guides, Ball Screws, Ball Screw Nut, LM Shafts, SBR (Lm shaft with Aluminium Support) , LM Bearing and Rack-Pinions etc. in Kathwada Ahmedabad Gujarat. Our goal is to deliver reliable motion solutions that power precision, performance, and productivity for industrial automation. As a trusted Rack and Pinion supplier in Ahmedabad, we ensure high-quality Linear Motion Components for your business needs.
            </p>

            <div className="hero-buttons">
              <a href="/products" className="btn primary-btn">
                Explore Products
              </a>
              <a href="/contact" className="btn secondary-btn">
                Contact Us
              </a>
            </div>
          </div>


          {/* RIGHT SIDE — IMAGE CAROUSEL */}
          <div className="hero-carousel">
            <Swiper
              modules={[Autoplay, EffectFade]}
              slidesPerView={1}
              effect="fade"
              loop={true}
              autoplay={{ delay: 2000, disableOnInteraction: false }}
              // pagination={{ clickable: true }}
              className="hero-swiper"
            >
              {(products.length > 0 ? products : [{ imageUrl: '/images/placeholder.jpg', name: 'Loading...' }]).map( (product, index) => ( <SwiperSlide key={index}> <img src={product.imageUrl} alt={product.name || 'Product Image'} className="w-full h-full object-contain" /> </SwiperSlide> ) )}
            </Swiper>
          </div>
        </div>
      </section>


      <section className="about">
        <div className="about-container">
          {/* LEFT IMAGE */}
          <div className="about-image">
            <img src="/images/home/breadchrumb.png" alt="About JB Corporation Ahmedabad Gujarat" title="JB Corporation Linear Motion Products" />
          </div>

          {/* RIGHT CONTENT */}
          <div className="about-content">
            <h2>
              About <span>JB Corporation</span>
            </h2>
            <p>
              JB Corporation is a leading importer and supplier of Linear Motion Products in Ahmedabad Gujarat India from Last Many Years.
              We specialize in delivering precision-engineered components that drive accuracy and efficiency in industrial applications.
              Our mission is to provide quality products, reliable support, and long-term value to our customers in Kathwada Ahmedabad.
            </p>

            <div className="about-features">
              <div className="feature">
                <i className="fa-solid fa-industry"></i>
                <span>High-Quality Manufacturing</span>
              </div>
              <div className="feature">
                <i className="fa-solid fa-users"></i>
                <span>Skilled & Experienced Team</span>
              </div>
              <div className="feature">
                <i className="fa-solid fa-lightbulb"></i>
                <span>Innovative Engineering</span>
              </div>
              <div className="feature">
                <i className="fa-solid fa-shield-halved"></i>
                <span>Trusted Quality & Reliability</span>
              </div>
            </div>

            <a href="/about" className="btn about-btn">
              Learn More
            </a>
          </div>
        </div>
      </section>

<section className="relative py-20 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
  <div className="container mx-auto px-4">
    {/* Heading */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
        Our <span className="text-indigo-600">Products</span>
      </h2>
      <p className="text-gray-500 max-w-2xl mx-auto text-base">
        Explore our range of precision-engineered products designed for
        performance, reliability, and innovation. Leading supplier of Rack & Pinion, Ball Screws, and Linear Motion Guides in Ahmedabad Gujarat.
      </p>
    </div>

    {/* Swiper */}
    <Swiper
      modules={[Pagination, Autoplay]}
      spaceBetween={30}
      slidesPerView={3}
      loop
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      pagination={{ clickable: true }}
      breakpoints={{
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
      className="product-swiper"
    >
      {products?.map((product) => (
        <SwiperSlide key={product.id}>
          <div
            className="group relative bg-white rounded-2xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 cursor-pointer"
            onClick={() => setSelectedImage(product.imageUrl)}
          >
            {/* Product Image */}
            <div className="relative w-full h-100 overflow-hidden bg-gray-100">
              <img
                src={product.imageUrl}
                alt={product.name}
                className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-110"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              {/* Hover Button */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300">
                <button className="bg-white/80 backdrop-blur-md text-gray-800 px-3 py-2 rounded-full text-sm font-medium shadow-md flex items-center gap-2">
                  <i className="fa-solid fa-magnifying-glass-plus"></i> View
                </button>
              </div>
            </div>

            {/* Details */}
            <div className="p-5 text-center">
              <h3 className="text-lg font-semibold text-gray-800 group-hover:text-indigo-600 transition-colors duration-300">
                {product.name}
              </h3>
            </div>

            {/* Accent Bar */}
            <div className="absolute bottom-0 left-0 w-0 h-1 bg-indigo-500 group-hover:w-full transition-all duration-300"></div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>

    {/* Modal Overlay */}
    {selectedImage && (
            <div className="image-overlay" onClick={() => setSelectedImage(null)}>
              <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={() => setSelectedImage(null)}>
                  <i className="fa-solid fa-xmark"></i>
                </button>
                <img
                  src={selectedImage}
                  alt="Product View"
                  className="expanded-img"
                />
              </div>
            </div>
          )}
  </div>
</section>

      <section className="why-choose-us">
        <div className="why-container">
          <h2>
            Why <span>Choose Us</span>
          </h2>
          <p className="why-intro">
            At JB Corporation Ahmedabad, we believe in delivering excellence through
            innovation, reliability, and customer-focused solutions for Linear Motion Products in Gujarat India.
          </p>

          <div className="why-grid">
            <div className="why-card">
              <i className="fa-solid fa-industry"></i>
              <h3>High-Quality Manufacturing</h3>
              <p>
                We use advanced technology and precision engineering to ensure
                durability and superior performance for Rack & Pinion, Ball Screws, and LM Guides in Ahmedabad Gujarat.
              </p>
            </div>

            <div className="why-card">
              <i className="fa-solid fa-users-gear"></i>
              <h3>Expert Team</h3>
              <p>
                Our skilled professionals are dedicated to crafting innovative
                Linear Motion solutions tailored to your needs in Kathwada Ahmedabad.
              </p>
            </div>

            <div className="why-card">
              <i className="fa-solid fa-headset"></i>
              <h3>Reliable Support</h3>
              <p>
                We provide excellent after-sales support and maintenance to keep
                your industrial automation operations running smoothly with our Ball Screws and LM Guides.
              </p>
            </div>

            <div className="why-card">
              <i className="fa-solid fa-lightbulb"></i>
              <h3>Continuous Innovation</h3>
              <p>
                We constantly upgrade our products with the latest technology to
                stay ahead in the Linear Motion industry in Gujarat India.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="industries">
        <div className="industries-container">
          <h2>
            Industries <span>We Serve</span>
          </h2>
          <p className="industries-intro">
            JB Corporation proudly partners with diverse industries in Kathwada Ahmedabad Gujarat, delivering
            quality Linear Motion Products that empower businesses worldwide.
          </p>

          <div className="industries-grid">
            {industries.map((item, index) => (
              <div className="industry-card" key={index}>
                <i className={item.icon}></i>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="testimonials">
        <div className="testimonials-container">
          <h2>
            What Our <span>Clients Say</span>
          </h2>
          <p className="testimonials-intro">
            Hear from our trusted partners and clients who rely on JB Corporation Ahmedabad for excellence and innovation in Linear Motion Components.
          </p>

          <Swiper
            modules={[Pagination, Autoplay]}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            className="testimonials-swiper"
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {testimonials.map((t, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial-card">

                  <p className="testimonial-text">“{t.feedback}”</p>
                  <h3>{t.name}</h3>
                  {/* <span>{t.company}</span> */}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

             <BrandsWith />

      <section className="contact-cta">
        <div className="cta-container">
          <div className="cta-content">
            <h2>
              Ready to <span>Work Together?</span>
            </h2>
            <p>
              Partner with JB Corporation Ahmedabad Gujarat for innovative, reliable, and
              high-quality industrial Linear Motion solutions that drive your business forward.
            </p>

            <div className="cta-buttons">
              <a href="/contact" className="btn primary-btn">
                📞 Contact Us
              </a>
              <a href="/products" className="btn secondary-btn">
                Explore Products
              </a>
            </div>
          </div>
        </div>
      </section>











    </>

  )
}

export default Home
